import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  amtNumStr,
  amtStr,
} from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, { useContext } from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import { ResidualValueDetailContent } from './ResidualValueDetailContent'

export const ResidualValueDetail = (props: any) => {
  const history = useHistory()
  const { mode } = props
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const location = useLocation()
  const editData = location?.state as any

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/residual-value`
          )
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Residual Value', current: true },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="xsTitle flex-space">
            <span style={{ fontWeight: 'bold' }}>{editData?.Asset?.name}</span>
          </span>
        }
        rightText={<span className="xsTitle">{editData?.DocNo}</span>}
        infoLine={
          <>
            <div className="desc flex-space">
              {formatDate(editData?.change_date)}
            </div>
          </>
        }
        rightInfoLine={
          <span className="desc">
            <span style={{ color: '#666' }}>
              {amtStr(editData?.old_residual_amount)} |{' '}
              {editData?.old_residual_percent}%
            </span>
            <span> → </span>
            <span style={{ color: 'orange' }}>
              {amtStr(editData?.new_residual_amount)} |{' '}
              {editData?.new_residual_percent}%
            </span>
          </span>
        }
      />

      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <ResidualValueDetailContent
            listEl={editData}
            listStatus={editData?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>
      </ContentWrapper>
    </>
  )
}
